import React, { useContext } from "react";
import ShapesComp from "../middle.screen.parent.component/BasicShapes";
import MyContext from "../../context/MyContext";

const PreviewChangeableShapes = ({
  value,
  TickerStart,
  TickerPosition,
  zInd,
  CanvasDisplay,
  index,
  EditorZoom,
}) => {
  return (
    <>
      {value.opc === 1 && (
        <>
          <div
            className={"changer EditStart " + value.InClass + value.OutClass}
            id={"Preview-" + value.AnimationId}
            style={{
              VendorAnimationDuration: ".5s",
              // display: (value.player ? 'inline-block' : TickerStart ?
              //     (value.startPositionOnTimeline <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline) >= TickerPosition) ?
              //         'inline-block' : 'none'
              //     : (value.startPositionOnTimeline + value.startTransitionWidth <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline - value.startTransitionWidth) >= TickerPosition) ?
              //         'inline-block' : 'none'),
              display: !CanvasDisplay
                ? value.player
                  ? "inline-block"
                  : "none"
                : TickerStart
                ? value.startPositionOnTimeline <= TickerPosition &&
                  value.startPositionOnTimeline + value.widthOnTimeline >=
                    TickerPosition
                  ? "inline-block"
                  : "none"
                : value.startPositionOnTimeline + value.startTransitionWidth <=
                    TickerPosition &&
                  value.startPositionOnTimeline +
                    value.widthOnTimeline -
                    value.startTransitionWidth >=
                    TickerPosition
                ? "inline-block"
                : "none",
              //20 is shape anomoly.
              // height: (value.height * value.CanvasZoom) / 100 - 20,
              // width: (value.width * value.CanvasZoom) / 100 - 20,
              height: (value.height * value.CanvasZoom) / 100,
              width: (value.width * value.CanvasZoom) / 100,
              zIndex: zInd,
              left: value.x,
              top: value.y,
            }}
          >
            <ShapesComp value={value} index={index} fromPreview={true} />
          </div>
        </>
      )}
    </>
  );
};

export default PreviewChangeableShapes;
